module.exports = __webpack_public_path__ + "static/media/hospital-user.67031b77.svg";